import es from "react-phone-number-input/locale/es";

/**
 * Nombres de país del selector de teléfono, en castellano.
 *
 * El locale `es` que trae `react-phone-number-input` tiene nombres en inglés ("Jordan",
 * "Kenya", "Malaysia", "Zimbabwe"), nombres viejos ("Swazilandia", "Jamahiriya Árabe Libia",
 * "Holanda") y dos "Congo" iguales que no se pueden distinguir en la lista. Acá se corrigen
 * encima del locale de la librería, sin copiarlo entero.
 */
export const PHONE_COUNTRY_LABELS: typeof es = {
  ...es,
  country: "País",
  CD: "República Democrática del Congo",
  CG: "República del Congo",
  JO: "Jordania",
  KE: "Kenia",
  KZ: "Kazajistán",
  LA: "Laos",
  LY: "Libia",
  MK: "Macedonia del Norte",
  MY: "Malasia",
  NL: "Países Bajos",
  PS: "Palestina",
  RU: "Rusia",
  SS: "Sudán del Sur",
  SY: "Siria",
  SZ: "Esuatini",
  TL: "Timor Oriental",
  VI: "Islas Vírgenes de EE. UU.",
  ZW: "Zimbabue",
};
